export const GET_INSURANCES = "GET_INSURANCES";
export const GET_INSURANCE_BY_ID = "GET_INSURANCE_BY_ID";
export const SET_INSURANCE_TO_NULL = "SET_INSURANCE_TO_NULL";
